import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import styles from './TwofaSetup.module.css';

export default function TwofaSetup() {
  const navigate = useNavigate();
  const { herlaadGebruiker } = useAuth();
  const [otpUrl, setOtpUrl]           = useState('');
  const [secret, setSecret]           = useState('');
  const [code, setCode]               = useState('');
  const [fout, setFout]               = useState('');
  const [succes, setSucces]           = useState(false);
  const [laden, setLaden]             = useState(true);
  const [bevestigLaden, setBevestigLaden] = useState(false);
  const [qrImage, setQrImage]         = useState('');

  useEffect(() => {
    async function laadSetup() {
      try {
        const res = await axios.post('/api/auth/2fa/setup');
        setOtpUrl(res.data.otpUrl);
        setSecret(res.data.secret);
        const qr = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(res.data.otpUrl)}`;
        setQrImage(qr);
      } catch {
        setFout('Kon 2FA setup niet laden. Probeer opnieuw.');
      } finally {
        setLaden(false);
      }
    }
    laadSetup();
  }, []);

  async function handleBevestig(e) {
    e.preventDefault();
    setFout('');
    setBevestigLaden(true);
    try {
      await axios.post('/api/auth/2fa/bevestig', { code });
      setSucces(true);
      // Herlaad gebruikersdata zodat twofa_actief = true in de context staat
      await herlaadGebruiker();
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (err) {
      setFout(err.response?.data?.error || 'Ongeldige code. Probeer opnieuw.');
    } finally {
      setBevestigLaden(false);
    }
  }

  if (laden) return <div className={styles.laden}>Laden...</div>;

  return (
    <div className={styles.pagina}>
      <div className={styles.kaart}>
        <h1 className={styles.titel}>Tweestapsverificatie instellen</h1>
        <p className={styles.intro}>
          Alyden vereist tweestapsverificatie voor alle gebruikers.
          Volg de stappen hieronder om uw authenticator-app in te stellen.
        </p>

        {succes ? (
          <div className={styles.succes}>
            ✓ 2FA succesvol ingesteld. U wordt doorgestuurd naar het dashboard...
          </div>
        ) : (
          <>
            <div className={styles.stap}>
              <div className={styles.stapNr}>1</div>
              <div>
                <strong>Download een authenticator-app</strong>
                <p>Bijvoorbeeld Google Authenticator of Microsoft Authenticator.</p>
              </div>
            </div>
            <div className={styles.stap}>
              <div className={styles.stapNr}>2</div>
              <div>
                <strong>Scan de QR-code</strong>
                <p>Open de app en scan onderstaande code.</p>
              </div>
            </div>
            {qrImage && (
              <div className={styles.qrWrap}>
                <img src={qrImage} alt="QR code voor 2FA" className={styles.qr} />
                <details className={styles.handmatig}>
                  <summary>Handmatig invoeren</summary>
                  <code className={styles.secret}>{secret}</code>
                </details>
              </div>
            )}
            <div className={styles.stap}>
              <div className={styles.stapNr}>3</div>
              <div>
                <strong>Voer de verificatiecode in</strong>
                <p>Voer de 6-cijferige code in om de setup te bevestigen.</p>
              </div>
            </div>
            <form onSubmit={handleBevestig} className={styles.form}>
              <input
                type="text" inputMode="numeric" pattern="\d{6}" maxLength={6}
                value={code} onChange={e => setCode(e.target.value)}
                placeholder="000000" className={styles.codeInput} autoFocus required
              />
              {fout && <div className={styles.fout}>{fout}</div>}
              <button type="submit" className={styles.knop} disabled={bevestigLaden}>
                {bevestigLaden ? 'Controleren...' : '2FA bevestigen en activeren'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
